import { Building2, FileText, User } from 'lucide-react';
import { InfoRow } from './InfoRow';

interface CustomerInfoCardProps {
  clientName?: string;
  contractName?: string;
  notes?: string;
}

export function CustomerInfoCard({ clientName, contractName, notes }: CustomerInfoCardProps) {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-purple-50 dark:bg-purple-950 flex items-center justify-center">
          <User className="w-5 h-5 text-purple-600 dark:text-purple-400" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Customer Information</h3>
          <p className="text-xs text-muted-foreground">Client and contract details</p>
        </div>
      </div>

      <div className="space-y-4">
        <InfoRow icon={Building2} label="Client" value={clientName ?? 'Unknown'} />
        {contractName && <InfoRow icon={FileText} label="Contract" value={contractName} />}

        {notes && (
          <div className="pt-4 border-t border-border">
            <div className="text-xs text-muted-foreground mb-2">Notes</div>
            <p className="text-sm text-foreground">{notes}</p>
          </div>
        )}
      </div>
    </div>
  );
}
